import React from 'react';
import Step1CategorySelection from './Step1CategorySelection';
import Step2FormDetails from './Step2FormDetails';
import Step3Success from './Step3Success';
import ErrorDisplay from './ErrorDisplay';

const SubmissionForm = ({
  selectedCategory,
  submitted,
  error,
  isSubmitting,
  rubricData,
  categories,
  handleCategoryChange,
  handleFormSubmit,
  dynamicFormSchema,
}) => {
  return (
    <div className="space-y-8">
      {/* Step 1: Category Selection - Only show when no category selected */}
      {!selectedCategory && (
        <Step1CategorySelection
          selectedCategory={selectedCategory}
          categories={categories}
          handleCategoryChange={handleCategoryChange}
        />
      )}

      {/* Step 2: Form Details - Only show when category is selected and not submitted */}
      {selectedCategory && !submitted && (
        <Step2FormDetails
          selectedCategory={selectedCategory}
          dynamicFormSchema={dynamicFormSchema}
          handleFormSubmit={handleFormSubmit}
          isSubmitting={isSubmitting}
          rubricData={rubricData}
        />
      )}

      {/* Step 3: Success Message - Only show when submitted */}
      {submitted && <Step3Success selectedCategory={selectedCategory} />}

      {/* Error Display */}
      <ErrorDisplay error={error} />
    </div>
  );
};

export default SubmissionForm;
